import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_RADIUS_PARSER_OPTIONS = '/rpoptions';

export const SET_RADIUS_PARSER_OPTIONS_LOADING = 'SET_RADIUS_PARSER_OPTIONS_LOADING';
export const GO_TO_RADIUS_PARSER_OPTIONS_CREATE = 'GO_TO_RADIUS_PARSER_OPTIONS_CREATE';
export const GO_TO_RADIUS_PARSER_OPTIONS_EDIT = 'GO_TO_RADIUS_PARSER_OPTIONS_EDIT';
export const GO_TO_RADIUS_PARSER_OPTIONS_VIEW = 'GO_TO_RADIUS_PARSER_OPTIONS_VIEW';
export const GET_RADIUS_PARSER_OPTIONS = 'GET_RADIUS_PARSER_OPTIONS';
export const GET_RADIUS_PARSER_OPTIONS_PENDING = 'GET_RADIUS_PARSER_OPTIONS_PENDING';
export const GET_RADIUS_PARSER_OPTIONS_FULFILLED = 'GET_RADIUS_PARSER_OPTIONS_FULFILLED';
export const UPDATE_RADIUS_PARSER_OPTIONS = 'UPDATE_RADIUS_PARSER_OPTIONS';
export const UPDATE_RADIUS_PARSER_OPTIONS_FULFILLED = 'UPDATE_RADIUS_PARSER_OPTIONS_FULFILLED';
export const UPDATE_RADIUS_PARSER_OPTIONS_REJECTED = 'UPDATE_RADIUS_PARSER_OPTIONS_REJECTED';
export const UPDATE_RADIUS_PARSER_OPTIONS_PENDING = 'UPDATE_RADIUS_PARSER_OPTIONS_PENDING';
export const CREATE_RADIUS_PARSER_OPTIONS = 'CREATE_RADIUS_PARSER_OPTIONS';
export const CREATE_RADIUS_PARSER_OPTIONS_FULFILLED = 'CREATE_RADIUS_PARSER_OPTIONS_FULFILLED';
export const CREATE_RADIUS_PARSER_OPTIONS_REJECTED = 'CREATE_RADIUS_PARSER_OPTIONS_REJECTED';

export enum RadiusParserOptionsPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface RadiusParserOptions {
  id: string,
  roId: string,
  ACCESS_REQ_TIMEOUT: string,
  DCFD_DYNIP_PROV: 'YES' | 'NO',
  DEPLOYMENT: 'GENERIC' | 'VM-NG-AFFW',
  HIST_DISK_LIMIT: string,
  HIST_ENCRYT: 'ON' | 'OFF',
  HIST_FILESIZE: string,
  LINKDOWNTIMEOUT: string,
  LISTENED_PORT: string,
  MAX_BUFFERED_MSG: string,
  MAX_SESSION_NUM: string,
  SESSION_DUMP_INTVL: string,
  SESSION_LIFETIME: string,
  SESSION_SYNC_INTVL: string,
  SESSION_TIMEOUT: string,
  STATS_INTVL: string,
  OWNER: string,
  GROUP: string,
  ACCESS: string
}

export interface RadiusParserOptionsState {
  entities: RadiusParserOptions[]
  selected: RadiusParserOptions[],
  single: RadiusParserOptions | null
  createdId: string | null
  ui: RadiusParserOptionsUIState
}

export interface RadiusParserOptionsUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
  isSaving: boolean
}

export interface SetRadiusParserOptionsLoadingAction extends AnyAction {
  type: typeof SET_RADIUS_PARSER_OPTIONS_LOADING
  payload: { isLoading: boolean }
}

export interface GetRadiusParserOptionsAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_OPTIONS
  payload: AxiosPromise<ServerResponse<RadiusParserOptions>>
}

export interface GetRadiusParserOptionsPendingAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_OPTIONS_PENDING
  payload: null
}

export interface GetRadiusParserOptionsFulfilledAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export interface UpdateRadiusParserOptionsThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateRadiusParserOptionsAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_OPTIONS
  payload: AxiosPromise<ServerResponse<RadiusParserOptions>>
}

export interface UpdateRadiusParserOptionsFulfilledAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export interface UpdateRadiusParserOptionsRejectedAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export interface UpdateRadiusParserOptionsPedingAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_OPTIONS_PENDING
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export interface CreateRadiusParserOptionsThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateRadiusParserOptionsAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_OPTIONS
  payload: AxiosPromise<ServerResponse<RadiusParserOptions>>
}

export interface CreateRadiusParserOptionsFulfilledAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_OPTIONS_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export interface CreateRadiusParserOptionsRejectedAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_OPTIONS_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserOptions>>
}

export type RadiusParserOptionsActionTypes =
  SetRadiusParserOptionsLoadingAction |
  GetRadiusParserOptionsAction |
  GetRadiusParserOptionsPendingAction |
  GetRadiusParserOptionsFulfilledAction |
  UpdateRadiusParserOptionsAction |
  UpdateRadiusParserOptionsPedingAction |
  UpdateRadiusParserOptionsFulfilledAction |
  UpdateRadiusParserOptionsRejectedAction |
  CreateRadiusParserOptionsAction |
  CreateRadiusParserOptionsFulfilledAction |
  CreateRadiusParserOptionsRejectedAction;
